/* lua.js generated code 0.3.0 */

module.exports = table(
    [1, UserDealPayType.kUnsupport, require("clover/logic/userDeal/UserDealPayTypeBase")],
    [1, UserDealPayType.kCoin, require("clover/logic/userDeal/UserDealPayTypeCoin")],
    [1, UserDealPayType.kCash, require("clover/logic/userDeal/UserDealPayTypeCash")],
    [1, UserDealPayType.kIngame, require("clover/logic/userDeal/UserDealPayTypeIngame")]
)
